import React from "react";

export function QuickFiltersPanel({ children, className = "" }) {
  return <div className={`bg-white rounded-lg shadow-sm p-4 mb-4 ${className}`}>{children}</div>;
}

// Shared presentation for record filters; each screen owns its fields and queries.
export function QuickFiltersHeader({ children }) {
  return (
    <div className="flex justify-between items-center mb-4">
      <div className="text-sm font-medium text-gray-700">Quick Filters</div>
      <div className="flex space-x-3">{children}</div>
    </div>
  );
}

export function QuickFiltersRow({ children, layout = "row" }) {
  return <div className={layout === "grid" ? "grid grid-cols-5 gap-4" : "flex gap-4 mb-2"}>{children}</div>;
}

export function AppliedFiltersRow({ children }) {
  return <div className="flex gap-4 mb-4 mt-4 flex-wrap">{children}</div>;
}
